<template>
  <div>
    <div class="box box-success no-padding">
      <div class="box-header with-border">
        <h3 class="box-title box-title-sub"><img src="/static/img/icons/entregadas.png"> Transporte</h3>
        <!-- <div class="pull-right">
          <button class="btn btn-sm btn-success btn-detail" @click="showDetail()">Ver Detalle</button>
        </div> -->
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12">
                <chart-line :chart-data="chartData" :height="240"></chart-line>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-sm-12">
                <div style="width: 300px;" class="center-block">
                  <div style="width: 150px; border-right:1px solid #eee;" class="pull-left text-center">
                    <img src="/static/img/icons/ic_delivery_system@3x.png" style="vertical-align: text-bottom" alt="Ingresadas" height="20" width="20">
                    <span class="span-value" v-bind:style="{color: this.colorEntered}">
                      {{totalGuidesTransit}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                    </span>
                    <br/>
                    <span class="span-unit">Guías de Remisión</span>
                    <br/>
                    <span class="span-status">en Tránsito</span>
                  </div>
                  <div style="width: 150px;" class="pull-right text-center">
                    <img src="/static/img/icons/ic_delivery_shipped@3x.png" style="vertical-align: text-bottom" alt="Ingresadas" height="20" width="22">
                    <span class="span-value" v-bind:style="{color: this.colorDelivered}">
                      {{totalGuidesDelivered}}<span style="font-size: 14px"> {{this.fetchData.minimumStockUnit}}</span>
                    </span>
                    <br/>
                    <span class="span-unit">Guías de Remisión</span>
                    <br/>
                    <span class="span-status">Entregadas</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import util from 'assets/js/util.js'
import constants from 'assets/js/constants.js'
import LineChart from 'charts/LineChart.js'

export default {
  name: 'TransportSummary',
  props: [
    'mode',
    'fetchData'
  ],
  data () {
    return {
      chartData: {},
      colorEntered: '',
      colorDelivered: ''
    }
  },
  watch: {
    fetchData: function (newVal, oldVal) {
      this.fillData()
    }
  },
  computed: {
    totalGuidesTransit: function () {
      var sumTransit = 0
      this.fetchData.guidesEnteredValuesTransport.forEach(e => { sumTransit += e.value })
      console.log(sumTransit)
      return this.$options.filters.formatAmount(sumTransit)
    },
    totalGuidesDelivered: function () {
      var sumDelivered = 0
      this.fetchData.guidesDeliveredValuesTransport.forEach(e => { sumDelivered += e.value })
      console.log(sumDelivered)
      return this.$options.filters.formatAmount(sumDelivered)
    },
    ...mapGetters([
      'dashboardFilter'
    ])
  },
  created () {
    this.colorEntered = constants.colorPalette.TransportEntered
    this.colorDelivered = constants.colorPalette.TransportDelivered
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      this.chartData = {
        labels: util.getChartLabels(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate),
        datasets: [
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.guidesEnteredValuesTransport),
            label: 'Ingresado',
            borderColor: constants.colorPalette.TransportEntered,
            fill: false
          },
          {
            data: util.getChartData(this.mode, this.dashboardFilter.startDate, this.dashboardFilter.endDate, this.fetchData.guidesDeliveredValuesTransport),
            label: 'Entregado',
            borderColor: constants.colorPalette.TransportDelivered,
            fill: false
          }
        ]
      }
    },
    showDetail () {
      this.$parent.showDetail('transport')
    }
  },
  components: {
    'chart-line': LineChart
  }
}
</script>



// WEBPACK FOOTER //
// TransportSummary.vue?525b14c4